import { render } from "./VvNewsCard.vue?vue&type=template&id=2c864e10&scoped=true"
import script from "./VvNewsCard.vue?vue&type=script&lang=js"
export * from "./VvNewsCard.vue?vue&type=script&lang=js"

import "./VvNewsCard.vue?vue&type=style&index=0&id=2c864e10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c864e10"]])

export default __exports__